import React from 'react'
import Layout from '../components/Layout'
import PoloMap from '../components/PoloMap'

function InfoField({ label, value }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 py-2">
      <label className="text-sm font-medium text-gray-700 sm:w-48">{label}</label>
      <input
        type="text"
        value={value || ''}
        readOnly
        className="flex-1 px-3 py-2 border border-gray-300 rounded-md bg-gray-50 text-sm"
        placeholder={label}
      />
    </div>
  )
}

export default function Polos({ polo }) {
  if (!polo) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-[50vh]">
          <p className="text-gray-500">Nenhum polo selecionado</p>
        </div>
      </Layout>
    )
  }

  return (
    <Layout>
      <div className="py-8">
        <h1 className="text-2xl font-bold text-brand-dark mb-6 font-heading">
          {polo.nome || 'Polo Varejista'}
        </h1>

        <div className="grid lg:grid-cols-2 gap-6">
          {/* Form Section */}
          <div className="border border-gray-800 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-brand-dark mb-4">Informações do Polo</h2>

            <InfoField label="Tipos" value={polo.tipos} />
            <InfoField label="Pontos" value={polo.pontos} />
            <InfoField label="Nível" value={polo.nivel} />
            <InfoField label="URL do vídeo" value={polo.video_url} />
            <InfoField label="Data do Levantamento" value={polo.data_levantamento} />
            <InfoField label="Barreira Urbana" value={polo.barreira_urbana} />
            <InfoField label="Continuidade do Traçado" value={polo.continuidade_tracado} />
            <InfoField label="Equipamento urbano" value={polo.equipamento_urbano} />
            <InfoField label="Terminal de Transporte" value={polo.terminal_transporte} />
            <InfoField label="Ônibus" value={polo.onibus} />
            <InfoField label="Ruídos Sonoros" value={polo.ruidos_sonoros} />
            <InfoField label="Observações" value={polo.observacoes} />
            <InfoField label="Distinção do Nome" value={polo.distincao_nome} />
          </div>

          {/* Map Section */}
          <div className="border border-gray-800 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-brand-dark mb-4">Mapa</h2>
            <PoloMap poloId={polo.id} />
          </div>
        </div>

        {/* Video Section */}
        {polo.video_url && (
          <div className="mt-6 border border-gray-800 rounded-lg p-4">
            <h2 className="text-lg font-semibold text-brand-dark mb-4">Vídeo</h2>
            <div className="aspect-video">
              <iframe
                src={polo.video_url}
                className="w-full h-full rounded"
                allowFullScreen
                title="Vídeo do Polo"
              />
            </div>
          </div>
        )}

        {/* Charts Section - Placeholder */}
        <div className="mt-6">
          <h2 className="text-xl font-bold text-brand-dark mb-4 font-heading">Gráficos Comparativos</h2>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="border border-gray-300 rounded-lg p-8 text-center text-gray-400">
              Gráfico 1
            </div>
            <div className="border border-gray-300 rounded-lg p-8 text-center text-gray-400">
              Gráfico 2
            </div>
            <div className="border border-gray-300 rounded-lg p-8 text-center text-gray-400">
              Gráfico 3
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
